import {
  cardMutedTextClass,
  cardSurfaceClass,
  cardTitleTextClass,
  ghostBtnClass,
  inputClass,
  mfgAccentBtnClass,
} from "@/components/manufacturing/manufacturingSurfaceClasses";
import type { MfgBomAuditKind } from "@/lib/manufacturing/types/bomAudit";
import { MFG_BOM_AUDIT_KIND_LABELS } from "@/lib/manufacturing/types/bomAudit";

type RecipeOption = { id: string; name: string; code?: string };

type Props = {
  recipes: RecipeOption[];
  plants: Array<{ id: string; name: string; plant_code?: string }>;
  recipeId: string;
  auditKind: MfgBomAuditKind;
  plantId: string;
  notes: string;
  busy: boolean;
  onRecipeId: (v: string) => void;
  onAuditKind: (v: MfgBomAuditKind) => void;
  onPlantId: (v: string) => void;
  onNotes: (v: string) => void;
  onOpen: () => void;
};

const labelClass = `flex flex-col gap-1 text-xs text-gray-700 dark:text-zinc-300`;

export function ManufacturingBomAuditOpenForm(props: Props) {
  return (
    <div className={`flex flex-col gap-3 p-4 ${cardSurfaceClass}`}>
      <div className={`text-sm font-medium ${cardTitleTextClass}`}>Start BOM audit</div>
      <p className={`text-xs ${cardMutedTextClass}`}>
        Choose how you want to check the recipe: audit the parts list for accuracy, or audit an
        active build for correct parts usage.
      </p>
      <label className={labelClass}>
        Recipe
        <select
          className={inputClass}
          value={props.recipeId}
          disabled={props.busy}
          onChange={(e) => props.onRecipeId(e.target.value)}
        >
          <option value="">Select recipe…</option>
          {props.recipes.map((r) => (
            <option key={r.id} value={r.id}>
              {r.code ? `${r.code} — ${r.name}` : r.name}
            </option>
          ))}
        </select>
      </label>
      <label className={labelClass}>
        Audit kind
        <select
          className={inputClass}
          value={props.auditKind}
          disabled={props.busy}
          onChange={(e) => props.onAuditKind(e.target.value as MfgBomAuditKind)}
        >
          {(Object.keys(MFG_BOM_AUDIT_KIND_LABELS) as MfgBomAuditKind[]).map((k) => (
            <option key={k} value={k}>
              {MFG_BOM_AUDIT_KIND_LABELS[k]}
            </option>
          ))}
        </select>
      </label>
      <label className={labelClass}>
        Plant (optional)
        <select
          className={inputClass}
          value={props.plantId}
          disabled={props.busy}
          onChange={(e) => props.onPlantId(e.target.value)}
        >
          <option value="">None</option>
          {props.plants.map((p) => (
            <option key={p.id} value={p.id}>
              {p.plant_code ? `${p.plant_code} — ${p.name}` : p.name}
            </option>
          ))}
        </select>
      </label>
      <label className={labelClass}>
        Session notes
        <textarea
          className={inputClass}
          rows={2}
          value={props.notes}
          disabled={props.busy}
          onChange={(e) => props.onNotes(e.target.value)}
          placeholder="Org-specific tracking notes…"
        />
      </label>
      <div className="flex gap-2">
        <button
          type="button"
          className={mfgAccentBtnClass}
          disabled={props.busy || !props.recipeId}
          onClick={props.onOpen}
        >
          Open audit
        </button>
        <span className={`${ghostBtnClass} pointer-events-none opacity-0`}>.</span>
      </div>
    </div>
  );
}
